export default from './Announcement';



// WEBPACK FOOTER //
// ./src/components/Announcement/index.js